var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,0H5.5C2.468,0,0,2.467,0,5.5V13.5c0,3.033,2.468,5.5,5.5,5.5h5v2h-3c-.828,0-1.5,.671-1.5,1.5s.672,1.5,1.5,1.5h9c.828,0,1.5-.671,1.5-1.5s-.672-1.5-1.5-1.5h-3v-2h5c3.032,0,5.5-2.467,5.5-5.5V5.5c0-3.033-2.468-5.5-5.5-5.5Zm2.5,13.5c0,1.378-1.121,2.5-2.5,2.5H5.5c-1.379,0-2.5-1.122-2.5-2.5V5.5c0-1.378,1.121-2.5,2.5-2.5h13c1.379,0,2.5,1.122,2.5,2.5V13.5Zm-8-4c0,.741-.215,1.425-.566,2.02l-2.141-2.141c-.188-.188-.293-.442-.293-.707v-3.03c1.722,.446,3,1.997,3,3.859Zm-4.121,1.293l2.142,2.142c-.913,.538-2.038,.757-3.251,.369-1.346-.43-2.403-1.581-2.684-2.965-.451-2.22,.939-4.185,2.915-4.697v3.03c0,.796,.316,1.559,.879,2.121Zm10.121-4.293c0,.829-.672,1.5-1.5,1.5h-1c-.828,0-1.5-.671-1.5-1.5s.672-1.5,1.5-1.5h1c.828,0,1.5,.671,1.5,1.5Zm0,5c0,.829-.672,1.5-1.5,1.5h-1c-.828,0-1.5-.671-1.5-1.5s.672-1.5,1.5-1.5h1c.828,0,1.5,.671,1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpIcon);
export default __webpack_public_path__ + "static/media/erp-icon.7dca972645209c87a219fa14311b6f33.svg";
export { ForwardRef as ReactComponent };